import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = guest, obj = user

  const checkAuth = useCallback(async () => {
    // Geçici ağ/5xx hatalarında kullanıcıyı oturumsuz sayma; kısa aralıklarla tekrar dene.
    // Sadece gerçek 401/403'te (kimlik doğrulanmadı) misafir moduna geç.
    for (let attempt = 0; attempt < 4; attempt++) {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        return;
      } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          setUser(false);
          return;
        }
        // ağ/5xx/timeout → artan bekleme ile yeniden dene
        await new Promise((r) => setTimeout(r, 700 * (attempt + 1)));
      }
    }
    // Tüm denemeler ağ hatasıyla başarısız: mevcut oturumu koru, aksi halde misafir.
    setUser((prev) => (prev && prev !== false ? prev : false));
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.debug("logout request failed (ignored):", err?.message);
    }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
